export default "__VITE_PUBLIC_ASSET__fd894d10__"